// extracted by mini-css-extract-plugin
module.exports = {"grid":"faqs_grid__2yL0k","text":"faqs_text__oYXGT","faqs":"faqs_faqs__3gfzf","phAnimation":"faqs_phAnimation__v3Pqs"};